const form = () => {
    // Confirme
    document.addEventListener('click', function(event) {
        if (event.target.matches('.confirm')) {
            let str = 'Êtes-vous sûr';
            if (event.target.getAttribute('title') !== undefined && event.target.getAttribute('title') !== '') {
                str += ` de vouloir\n"${event.target.getAttribute('title')}"`;
            }
            str += ' ?';
            return confirm(str);
        }
    });

    // Gestion CB required
    // Sélection des éléments avec l'attribut data-required-cb
    const requiredCBElements = document.querySelectorAll('div[data-required-cb], span[data-required-cb]');
    requiredCBElements.forEach(element => {
        // Récupération des checkbox dans l'élément courant
        const checkboxes = element.querySelectorAll('input[type="checkbox"]');
        const requiredCount = parseInt(element.getAttribute('data-required-cb'), 10);

        // Gestion de l'événement "change" sur chaque checkbox
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;

                if (checkedCount >= requiredCount) {
                    // Valider toutes les cases et supprimer l'exigence "required"
                    checkboxes.forEach(cb => {
                        cb.setCustomValidity('');
                        cb.required = false;
                    });
                } else {
                    // Ajouter un message de validation personnalisée aux cases non cochées
                    checkboxes.forEach(cb => {
                        if (!cb.checked) {
                            cb.setCustomValidity(`Veuillez cocher au moins ${requiredCount} option(s)`);
                        }
                    });
                }
            });
        });

        // Configuration initiale pour rendre certaines cases "required" si besoin
        const initialCheckedCount = Array.from(checkboxes).filter(cb => cb.checked).length;
        if (initialCheckedCount < requiredCount) {
            checkboxes.forEach(cb => {
                if (!cb.checked) {
                    cb.required = true;
                }
            });
        }
    });

    // Gestion de l'étoile
    // Pour les champs obligatoires (sauf checkbox et radio)
    const requiredElements = document.querySelectorAll('input[required], select[required], textarea[required]');
    requiredElements.forEach(element => {
        if (!element.matches('input[type=checkbox], input[type=radio]')) {
            const form = element.closest('form');
            if (form) {
                const label = form.querySelector(`label[for="${element.id}"]`);
                if (label) {
                    const span = document.createElement('span');
                    span.className = 'obligatoire';
                    span.innerHTML = '*';
                    label.appendChild(span);
                }
            }
        }
    });

    // Pour les checkbox, radio et éléments avec data-required-cb
    const requiredOther = document.querySelectorAll('input[required][type="checkbox"], input[required][type="radio"], div[data-required-cb], span[data-required-cb]');
    requiredOther.forEach(element => {
        const fieldset = element.closest('fieldset');
        if (fieldset) {
            const legend = fieldset.querySelector('legend');
            if (legend) {
                const span = document.createElement('span');
                span.className = 'obligatoire';
                span.innerHTML = '*';
                legend.appendChild(span);
            }
        }
    });


    // Gestion nb caractère max
    // Sélection des champs avec l'attribut data-maxchar
    const maxCharElements = document.querySelectorAll('textarea[data-maxchar], input[data-maxchar]');
    maxCharElements.forEach(element => {
        // Ajout de l'attribut aria-describedby
        const id = element.id;
        const maxCharId = `${id}_max`;
        element.setAttribute('aria-describedby', maxCharId);

        // Création et insertion du paragraphe pour afficher les commentaires
        const p = document.createElement('p');
        p.className = 'o-form-control__comment';
        p.id = maxCharId;
        p.setAttribute('aria-live', 'polite');
        element.insertAdjacentElement('afterend', p);

        // Fonction de mise à jour du compteur
        function updateCharacterCount() {
            const currentLength = element.value.length;
            const maxLength = parseInt(element.getAttribute('data-maxchar'), 10);
            p.innerHTML = `Nombre de caractères : ${currentLength} / ${maxLength}`;

            if (currentLength > maxLength) {
                p.style.color = 'red';
            } else {
                p.style.color = '';
            }
        }

        // Ajout de l'écouteur pour l'événement "keyup"
        element.addEventListener('keyup', updateCharacterCount);

        // Appel initial pour mettre à jour l'état
        updateCharacterCount();
    });

}

document.addEventListener('DOMContentLoaded', form);
